<script setup lang="ts">
import type { AppFlickerBorderRadius, AppFlickerSize } from '@libs/ui';
import { AppFlicker } from '@libs/ui';

const width: AppFlickerSize = '100%';
const height: AppFlickerSize = 'spacing-24';
const borderRadius: AppFlickerBorderRadius = 'border-radius-8';
</script>

<template>
  <div class="hotel-description-opening-paragraph-section-loader">
    <AppFlicker :width="width" :height="height" :border-radius="borderRadius" />
  </div>
</template>

<style scoped lang="scss">
.hotel-description-opening-paragraph-section-loader {
  padding-top: var(--spacing-16);
  padding-bottom: var(--spacing-32);
}
</style>
